import { apiProvider } from "./core/provider";

const apiEntitlements = {};

// The current user's resolved feature-key set.
apiEntitlements.mine = function () {
  return apiProvider.get("entitlements");
};

apiEntitlements.listKeys = function () {
  return apiProvider.get("entitlements/keys");
};

apiEntitlements.listGrants = function () {
  return apiProvider.get("entitlements/grants");
};

apiEntitlements.createGrant = function (grant) {
  return apiProvider.post("entitlements/grants", grant);
};

apiEntitlements.updateGrant = function (id, grant) {
  return apiProvider.put(`entitlements/grants/${id}`, grant);
};

apiEntitlements.deleteGrant = function (id) {
  return apiProvider.delete("entitlements/grants", id);
};

apiEntitlements.whoHas = function (key) {
  return apiProvider.get(`entitlements/keys/${encodeURIComponent(key)}/who-has`);
};

apiEntitlements.listCompanies = function () {
  return apiProvider.get("entitlements/companies");
};

apiEntitlements.listUsers = function () {
  return apiProvider.get("entitlements/users");
};

export { apiEntitlements };